export enum LoginResult {
  Success = 0,
  Fail = 1,
  InternalAuthNotEnabled = 2,
  TooManyAttempts = 3,
  NoPassword = 4,
}

export interface LoginDto {
  email: string;
  password: string;
}

export interface TokenPairDto {
  accessToken: string;
  refreshToken: string;
  refreshTokenExpiresAt: number;
}

export interface LoginResultDto {
  result: LoginResult;
  token?: TokenPairDto;
}

export interface RefreshDto {
  refreshToken: string;
}

export interface PasswordResetRequestDto {
  email: string;
}

export interface PasswordResetRequestResponseDto {
  success: boolean;
}

export interface PasswordResetInfoDto {
  targetUserEmail: string;
  returnTo?: string;
  type: PasswordResetType;
}

export enum PasswordResetType {
  ForgotPassword = 0,
  InitialSet = 1,
}

export interface PasswordResetInfoRequestDto {
  code: string;
}

export interface ChangePasswordDto {
  oldPassword: string;
  newPassword: string;
}

export class PasswordResetDto {
  code: string;
  password: string;
}

export enum PasswordChangeResult {
  Success = 0,
  WeakPassword = 1,
  WrongCurrentPassword = 2,
}

export interface PasswordChangeResultDto {
  result: PasswordChangeResult;
}
